<template>
  <div id="add-admin-modal">

    <memlist-card class="add-user-card">

      <m-row>
        <m-col lg="12">
          <memlist-text-input
            :title="$t('USER.EMAIL')"
            v-model="local_user.email"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="6">
          <memlist-text-input 
            :title="$t('USER.FIRSTNAME')"
            v-model="local_user.firstname"
          />
        </m-col>

        <m-col lg="6">
          <memlist-text-input
            :title="$t('USER.LASTNAME')"
            v-model="local_user.lastname"
          />
        </m-col>
      </m-row>

    </memlist-card>
    
  </div>
</template>


<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';


export default {
  name: 'AddAdminRow',
  components: {

  },
  mixins: [ toasts ],
  emits: ['changed'],
  props: ['index'],
  computed: {
    ...mapGetters(['currentPeriodId', 'currentCompanyId', 'companies']),
  },
  mounted() {

  },
  data() {
    return {
      local_user: {},
    };
  },
  watch: {

    company_id(newValue, oldValue) {
      
    },

    local_user: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.$emit('changed', this.index, this.local_user);
      }
    }

  },
  methods: {

  }
};
</script>
